// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import brLocale from '@fullcalendar/core/locales/pt-br'
import csLocale from '@fullcalendar/core/locales/cs'
import deLocale from '@fullcalendar/core/locales/de'
import enLocale from '@fullcalendar/core/locales/en-gb'
import esLocale from '@fullcalendar/core/locales/es'
import frLocale from '@fullcalendar/core/locales/fr'
import itLocale from '@fullcalendar/core/locales/it'
import nlLocale from '@fullcalendar/core/locales/nl'
import plLocale from '@fullcalendar/core/locales/pl'
import ptLocale from '@fullcalendar/core/locales/pt'
import ruLocale from '@fullcalendar/core/locales/ru'
import svLocale from '@fullcalendar/core/locales/sv'
import trLocale from '@fullcalendar/core/locales/tr'
import zhLocale from '@fullcalendar/core/locales/zh-cn'


@Component({
    name: 'Button',
    components: {
        FullCalendar
    },
    mixins: [
        template,
    ]
})
export class Calendar extends Vue {

    @Prop()
    private events!: string

    @Prop({default: 'de'})
    private locale!: string

    @Prop({default: null})
    private eventRender!: Function | null

    get calendarLocal() {
        switch (this.locale) {
            case 'en':
                return 'en-gb'
            case 'br':
                return 'pt-br'
            case 'zh':
                return 'zh-cn'
            default:
                return this.locale
        }
    }

    private calendarPlugins = [ dayGridPlugin, listPlugin ]

    private locales = [ brLocale, csLocale, deLocale, enLocale, esLocale, frLocale, itLocale, nlLocale, plLocale, ptLocale, ruLocale, svLocale, trLocale, zhLocale ]

    private header = {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,listYear'
    }
}